if (!customElements.get('seyun-gallery')) customElements.define('seyun-gallery', class extends HTMLElement {
 connectedCallback() {
  if (this.initialized) return;
  this.track = this.querySelector('.sy-gallery-track');
  this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
  if (!this.track || !this.slides.length) return;
  this.initialized = true;
  this.listeners = new AbortController();
  const signal = this.listeners.signal;
  this.buttons = [...this.querySelectorAll('[data-gallery-to]')];
  this.prev = this.querySelector('[data-gallery-prev]');
  this.next = this.querySelector('[data-gallery-next]');
  this.count = this.querySelector('[data-gallery-count]');
  this.index = Math.min(this.index || 0, this.slides.length - 1);
  this.buttons.forEach(button => button.addEventListener('click', () => this.go(Number(button.dataset.galleryTo)), { signal }));
  this.prev?.addEventListener('click', () => this.go(this.index - 1), { signal });
  this.next?.addEventListener('click', () => this.go(this.index + 1), { signal });
  this.track.addEventListener('keydown', event => {
   if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
    event.preventDefault();
    this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
   }
  }, { signal });
  this.track.addEventListener('scroll', () => {
   cancelAnimationFrame(this.frame);
   this.frame = requestAnimationFrame(() => {
    if (!this.track.clientWidth) return;
    this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
    this.update();
   });
  }, { passive: true, signal });
  // Shopify selects a block without moving a custom horizontal gallery itself.
  document.addEventListener('shopify:block:select', event => {
   const blockId = event.detail?.blockId;
   const index = this.slides.findIndex(slide => blockId ? slide.dataset.blockId === blockId : slide.contains(event.target));
   if (index !== -1) this.go(index, true);
  }, { signal });
  this.resizeObserver = new ResizeObserver(() => this.go(this.index, true));
  this.resizeObserver.observe(this.track);
  this.update();
 }
 go(index, immediate = false) {
  if (!Number.isFinite(index)) return;
  this.index = Math.max(0, Math.min(this.slides.length - 1, index));
  this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: immediate || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  this.update();
 }
 update() {
  this.buttons.forEach((button, i) => {
   button.classList.toggle('is-active', i === this.index);
   button.setAttribute('aria-pressed', String(i === this.index));
  });
  if (this.count) this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
  if (this.prev) this.prev.disabled = this.index === 0;
  if (this.next) this.next.disabled = this.index === this.slides.length - 1;
 }
 disconnectedCallback() {
  this.listeners?.abort();
  this.resizeObserver?.disconnect();
  cancelAnimationFrame(this.frame);
  this.initialized = false;
 }
});
